import { Component, OnInit, Input } from '@angular/core';
import { IonIcon } from '@ionic/angular/standalone';

import { DemoozColor, DemoozColorPrimary } from '@demooz/types';

@Component({
  selector: 'demooz-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  imports: [IonIcon]
})
export class DemoozMessageComponent  implements OnInit {

    @Input({alias : 'type', required : false}) typeMessage: 'info'|'success'|'warning'|'error' = 'info';
    @Input({alias : 'icon', required : false}) iconMessage: string = '';
    @Input({alias : 'showIcon', required : false}) showIcon: boolean = true;
    @Input({alias : 'color', required : false}) colorButton: DemoozColor = DemoozColorPrimary;
    
    constructor() { }

    ngOnInit() {}

    getIcon(): string {
        let icon = '';
        if(this.iconMessage !== ''){
            icon = this.iconMessage;
        }
        else{
            switch(this.typeMessage){
                case 'info': 
                    icon = 'alert-circle-outline';
                    break;
                case 'success': 
                    icon = 'checkmark-circle-outline';            
                    break;
                case 'warning': 
                    icon = 'warning-outline';            
                    break;
                case 'error': 
                    icon = 'warning-outline';            
                    break;
            }
        }
        return icon;
    }
}
